import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TablePaginationExhibit1 as TablePagination } from "../../../common/table/table-pagination.component";
import { requestLogActions } from "./../../../../store/external/request-reducer/request-log.reducer";
import { requestDetailsActions } from "./../../../../store/external/request-reducer/request-details.reducer";
import { REQUEST_SUB_LINKS as RequestTable } from "../../../../constants/external-constants";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import "./../request-page.component.css";

class OrderRequestQuotationTable extends Component {
    constructor(props) {
        super();
    }

    componentWillMount() {
        this.props.setActiveRequestTable(RequestTable.quotationRequest.id);
        this.props.fetchRequestLogItems(0, RequestTable.quotationRequest.id);
    }

    openRequestModal = (item) => {
        const { setSelectedRequest, history } = this.props;
        setSelectedRequest(item, true);
        history.push("QuotationRequest/RequestDetail/Order/" + item.OrderId);
    };

    render() {
        const { orderQuotationData, orderQuotationLoaded, orderQuotationFetchError, fetchRequestLogItems, fetchSortedRequestData } = this.props;

        return (
            <div>
                {
                    orderQuotationLoaded ?
                        orderQuotationFetchError ?
                            <span> Error in fetching data. </span> :
                            <TablePagination
                                id={RequestTable.orderRequest.id}
                                columns={orderQuotationData.Headers}
                                pageList={orderQuotationData.Data.Items}
                                pages={orderQuotationData.Pagination}
                                rowClickAction={this.openRequestModal}
                                paginationAction={fetchRequestLogItems}
                                sortAction={fetchSortedRequestData}
                            /> :
                        <div>
                            <NoSubscription customClass="loading-page" title="Loading, Please Wait…" />
                        </div>
                }
            </div>
        );
    }
}

export default connect(
    state => {
        const { requestLog } = state;
        return {
            ...requestLog
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestLogActions, requestDetailsActions),
            dispatch
        )
)(OrderRequestQuotationTable);
